import * as React from 'react';
import { useState, useEffect } from 'react';
// @mui

import {
  DialogTitle,
  Divider,
  Box,
  Stack,
  Button,
  Container,
  createTheme,
  Typography,
  TextField,
  Modal,
  Snackbar,
  Alert,
  Grid,
} from '@mui/material';
import {  ThemeProvider } from '@mui/styles';

// components

export default function EditLeaveForm(props) {
  const theme = createTheme();
  // ---------------------Modal-------------------------------
  const [openModal, setOpenModal] = useState(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    // window.location.reload(); // add this line to refresh the page
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };
  const [openEditModal, setOpenEditModal] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [formData, setFormData] = useState(props.data);
  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedData = {
      ...formData,
    };
    // get token from local storage
    const storedToken = localStorage.getItem('userToken');

    // check if token then parse into json and use it
    const token = storedToken ? JSON.parse(storedToken) : null;
  
    if (token) {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      fetch(`https://quotationserver.aiodock.com/updateClient/${formData._id}`, {
        method: 'PUT',
        body: JSON.stringify(updatedData),
        headers,
      })
        .then((response) => response.json())
        .then((data) => {
          setFormData({
            clientName: '',
            clientAddress: '',
            city: '',
            company: '',
            clientDesignation: '',
            contactNo: '',
          });
          setOpenSnackbar(true);
        })
        .catch((error) => {
          console.error('Update failed:', error);
          // handle error response
        });
    } else {
      alert('token not found to fullfill this request or expired');
    }
  };
  useEffect(() => {
    if (openSnackbar) {
      const snackbarTimer = setTimeout(() => {
        props.onClose();
      }, 1500);

      return () => {
        clearTimeout(snackbarTimer);
      };
    }
    return undefined;
  }, [openSnackbar]);
  const handleChangeData = (event) => {
    const { name, value } = event.target;
    setFormData((formData) => ({
      ...formData,
      [name]: value,
    }));
  };
  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Modal open={openEditModal} onClose={props.onClose}>
            <Box sx={style}>
              <ThemeProvider theme={theme}>
                <DialogTitle id="customized-dialog-title" sx={{ textAlign: 'center' }}>
                  Update Client -{formData.clientName}-
                </DialogTitle>
                <Divider fullWidth />

                {/* <Button onClick={handleCloseModal}></Button> */}

                <Box component="form" id="modal-modal-description" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                  <Grid container>
                    <Grid item={6}>
                      <TextField
                        fullWidth
                        margin="normal"
                        required
                        label="Name"
                        value={formData.clientName}
                        name="clientName"
                        onChange={handleChangeData}
                        autoFocus
                        style={{ width: '22em', paddingRight: 5 }}
                      />
                    </Grid>
                    <Grid item={6}>
                      <TextField
                        style={{ width: '16.2em' }}
                        fullWidth
                        margin="normal"
                        required
                        label="Designation"
                        value={formData.clientDesignation}
                        name="clientDesignation"
                        onChange={handleChangeData}
                        autoFocus
                      />
                    </Grid>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      value={formData.clientAddress}
                      label="Address"
                      name="clientAddress"
                      onChange={handleChangeData}
                      autoFocus
                    />
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="phone"
                      value={formData.city}
                      label="City"
                      name="city"
                      onChange={handleChangeData}
                      autoComplete="category"
                      autoFocus
                    />
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="phone"
                      value={formData.company}
                      label="Company"
                      name="company"
                      onChange={handleChangeData}
                      autoComplete="company"
                      autoFocus
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      label="Contact No #"
                      value={formData.contactNo}
                      name="contactNo"
                      onChange={handleChangeData}
                      autoFocus
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Button type="submit" color="secondary" variant="contained" sx={{ mt: 3, mb: 2, width: '50%' }}>
                        Update
                      </Button>
                      <Button onClick={props.onClose} variant="outlined" sx={{ mt: 3, mb: 2, mx: 3, width: '50%' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </ThemeProvider>

              <Snackbar
                open={openSnackbar}
                autoHideDuration={3000} // set the Snackbar to auto-hide after 3 seconds
                onClose={() => setOpenSnackbar(false)} // set the function to close the Snackbar when it is clicked
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Alert variant="filled" severity="success" sx={{ width: '100%' }}>
                  Client Information Updated Succesfully!
                </Alert>
              </Snackbar>
            </Box>
          </Modal>
        </Stack>
      </Container>
    </>
  );
}
